/* AXIONIQ – jedna lišta s metami (dárek + doprava zdarma) v panelu košíku i na stránce košíku.
   Konfigurace: window.AXQ_GIFTBAR ze snippets/transition-cover.liquid */
(function () {
  var CFG = window.AXQ_GIFTBAR;
  if (!CFG || !CFG.milestones || !CFG.milestones.length) return;

  var HOSTS = '.mini-cart__main, #main-cart-items, .cart__items';
  var MAX = CFG.milestones[CFG.milestones.length - 1].at;
  var total = null, currency = null;
  var fetching = false, lastFetch = 0, timer = null, observer = null;

  function money(cents) {
    var v = Math.round(cents / 100);
    return String(v).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' ' + CFG.suffix;
  }

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function html(t) {
    var next = null, i;
    for (i = 0; i < CFG.milestones.length; i++) {
      if (t < CFG.milestones[i].at) { next = CFG.milestones[i]; break; }
    }
    var label = next
      ? CFG.nextText.replace('{remaining}', '<strong>' + money(next.at - t) + '</strong>')
                    .replace('{goal}', esc(next.goal))
      : CFG.allText;
    var pct = Math.max(1.5, Math.min(100, (t / MAX) * 100));
    var ticks = '';
    for (i = 0; i < CFG.milestones.length - 1; i++) {
      ticks += '<i style="left:' + ((CFG.milestones[i].at / MAX) * 100).toFixed(2) + '%"></i>';
    }
    var chips = '';
    for (i = 0; i < CFG.milestones.length; i++) {
      var m = CFG.milestones[i];
      chips += '<span class="axq-gb__ms' + (t >= m.at ? ' is-done' : '') + '">' +
               esc(m.label) + ' <b>' + money(m.at) + '</b></span>';
    }
    return '<div class="axq-gb__label">' + label + '</div>' +
           '<div class="axq-gb__track"><span style="width:' + pct.toFixed(2) + '%"></span>' + ticks + '</div>' +
           '<div class="axq-gb__row">' + chips + '</div>';
  }

  function paint() {
    if (observer) observer.disconnect();
    try {
      var active = total !== null && total > 0 && (!CFG.currency || currency === CFG.currency);
      document.documentElement.classList.toggle('axq-gb-on', !!active);
      var hosts = document.querySelectorAll(HOSTS);
      for (var i = 0; i < hosts.length; i++) {
        var host = hosts[i];
        var bar = host.querySelector('.axq-gb');
        if (bar && bar.parentNode !== host) bar = null;
        if (!active) { if (bar) bar.parentNode.removeChild(bar); continue; }
        if (!bar) {
          bar = document.createElement('div');
          bar.className = 'axq-gb';
          host.insertBefore(bar, host.firstChild);
        }
        var markup = html(total);
        if (bar.getAttribute('data-axq') !== markup) {
          bar.innerHTML = markup;
          bar.setAttribute('data-axq', markup);
        }
        if (total >= MAX) bar.classList.add('axq-gb--done');
        else bar.classList.remove('axq-gb--done');
      }
    } catch (e) {}
    connect();
  }

  function refresh(force) {
    var now = Date.now();
    if (fetching) return;
    if (!force && now - lastFetch < 700) { paint(); return; }
    fetching = true;
    lastFetch = now;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { total = c.total_price; currency = c.currency; fetching = false; paint(); })
      .catch(function () { fetching = false; });
  }

  function schedule() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () { refresh(false); }, 300);
  }

  function connect() {
    if (!observer || !document.body) return;
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function start() {
    refresh(true);
    try { observer = new MutationObserver(schedule); connect(); } catch (e) {}
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('[name="add"], .quantity__button, cart-remove-button, [data-cart-remove], .cart-remove-button')) {
        setTimeout(function () { refresh(true); }, 900);
      }
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();